"use client";

import { useTranslations } from "next-intl";
import { Logo } from "@repo/ui/components/ui/header/logo";
import Link from "next/link";
import { Separator } from "@repo/ui/components/ui/separator";
import Icon, { IconName } from "@repo/ui/components/ui/icon/icon";
import { Button } from "@repo/ui/components/ui/button";
import { cn } from "@repo/ui/lib/utils";

export function Footer() {
  const t = useTranslations("Footer");
  const keys = ["conditions"] as const;

  const socialIcons = [
    //"Facebook",
    { icon: "Instagram", link: "https://www.instagram.com/ipriceit" },
    //"Twitter",
    //"TikTok",
    { icon: "Linkedin", link: "https://www.linkedin.com/company/ipriceit" },
  ] as Array<{ icon: IconName; link: string }>;

  return (
    <div className="p-[40px] max-md:p-[24px] md:mb-20">
      <div className="flex items-center justify-between flex-wrap md:flex-nowrap">
        <div>
          <Logo />
        </div>
        <Separator className="my-6 md:hidden max-md:mb-0" />
        <div className="flex justify-end max-md:justify-center max-md:py-[20px]">
          <div className="flex gap-[25px]">
            <Link
              className="underline underline-offset-auto decoration-auto"
              href={"/privacy"}
            >
              {t("privacy")}
            </Link>
            <Link
              href="/help"
              className="underline underline-offset-auto decoration-auto"
            >
              {t("help")}
            </Link>
            <Link
              href="/cookie"
              className="underline underline-offset-auto decoration-auto"
            >
              {t("cookies")}
            </Link>
            <p className="max-md:hidden">{t("follow")}</p>
            {socialIcons.map((icon, index) => (
              <Link href={`${icon.link}`} key={index} target="_blank">
                <Icon
                  key={icon.icon}
                  icon={icon.icon}
                  className="h-[32px] *:fill-secondary-black dark:*:fill-primary-white"
                />
              </Link>
            ))}
          </div>
        </div>
      </div>
      <Separator className="mt-[10px] mb-[40px] max-md:hidden" />
      <div className="flex justify-between items-center flex-wrap">
        <div className="w-full md:w-auto">
          <p>{t("copyright")}</p>
        </div>

        <div className="flex flex-wrap md:flex-nowrap gap-4 w-full md:w-auto">
          {/*{keys.map((key) => (
            <div key={key} className="flex flex-col md:flex-row md:space-x-4">
              {t(`cols.${key}.items`)
                .split(",")
                .map((item) => (
                  <Link href={""} key={item}>
                    <div
                      className={cn(
                        "underline text-secondary-gray4 dark:text-secondary-gray1 font-normal",
                        "text-[16px] max-md:text-[12px] max-md:mt-[20px] no-underline",
                      )}
                    >
                      {item}
                    </div>
                  </Link>
                ))}
            </div>
          ))}*/}
          <Separator className="my-[24px] md:hidden" />
        </div>
      </div>
    </div>
  );
}
